module.exports = __webpack_public_path__ + "static/media/MealPlanSignup.a9b6c314.png";